import { FETCH_VEHICLES_REQUEST, FETCH_VEHICLES_SUCCESS, FETCH_VEHICLES_FAILED } from "./types";



export const fetchVechilesRequest = () => ({type:FETCH_VEHICLES_REQUEST})
export const fetchVechilesSuccess = (vehicles) => ({type:FETCH_VEHICLES_SUCCESS , payload : vehicles})
export const fetchVechilesFailed= (error) => ({type:FETCH_VEHICLES_FAILED, payload : error})
